import swiper from "./src/index";
const mycomponent = swiper;

mycomponent.install = function(Vue) {
  Vue.component(mycomponent.name, mycomponent);
};

export default mycomponent;



// WEBPACK FOOTER //
// ./src/packages/swiper/index.js